import React from 'react';
//react-router-dom
import { BrowserRouter } from 'react-router-dom';
import RoruterApp from './Router'
function App() {
  return (
    <BrowserRouter>
      <RoruterApp />
    </BrowserRouter>
  );
}

export default App;
